/* esm.sh - tailwindcss-cdn@3.4.10 */
export * from "/tailwindcss-cdn@3.4.10/es2022/tailwindcss-cdn.mjs";
export { default } from "/tailwindcss-cdn@3.4.10/es2022/tailwindcss-cdn.mjs";
